import axios from "@/axios";
import Util from "@/util/util";

export const namespaced = true

const defaultData = {
    orderId: 0,
    organizationId: null,
    lssTypeId: null,
    paymentMethodId: null,
    usBuySell: null,
    dodAac: null,
    hasAcsaCeiling: null,
    acsaCeilingJustification: null,
    isRatified: false
}

export const state = {
    preOrder: Object.assign({}, defaultData),
    preOrderErrors: [],
    status: false
}

export const getters = {
    preOrder: state => state.preOrder,
    preOrderStatus: state => state.status,
    preOrderErrors: state => state.preOrderErrors,
    isRikOrEveOrder: state => state.preOrder && (state.preOrder.paymentMethodId === Util.RIK || state.preOrder.paymentMethodId === Util.EVE),
    isMonetaryOrder: state => state.preOrder && state.preOrder.paymentMethodId === Util.MONETARY,
    isUsBuyOrder: state => state.preOrder && state.preOrder.usBuySell === Util.US_BUY,
    isUsSellOrder: state => state.preOrder && state.preOrder.usBuySell === Util.US_SELL,
    isOrderRatified: state => state.preOrder && state.preOrder.isRatified,
}

export const mutations = {
    SET_PRE_ORDER: (state, response) => {
        state.preOrder = Object.assign({}, defaultData, response.data)
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.preOrder = Object.assign({}, defaultData)
    },
    SET_ERRORS(state, data) {
        state.preOrderErrors = data;
    },
    CLEAR_ERRORS(state) {
        state.preOrderErrors = [];
    }
}

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getPreOrder({ commit }, id) {
        var response = await axios.get(`/api/orders/preorder/${id}/`)
        // if new just pull the organization so when the mapping happens the other props arent affected
        if(id <= 0) {
            response.data = { organizationId: response.data.organizationId }
        }

        commit("SET_PRE_ORDER", response)
    },
    async getPreOrderStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false)
        } else {
            return await axios.get('/api/orders/status/' + id)
                .then(({ data }) => {
                    if(data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },

    updatePreOrderStatus({ commit },status) {
        commit("SET_STATUS", status)
    },

    savePreOrder({ commit, state}, preOrderData) {
        return new Promise((resolve, reject) => {
            const dataToSend = Object.assign({}, state.preOrder);

            //The DODAAC must be null or a valid 6 character string when sent to the server.  If it is an empty string set it to null.
            if (!Util.isNull(dataToSend) && Util.isNullOrEmpty(dataToSend.dodAac)) {
                dataToSend.dodAac = null;
            }

            axios.post('/api/orders', dataToSend,  { config:{ showToast: false, message: "Pre-Order Details Saved"}})
                .then(({ data }) => {
                    commit("SET_PRE_ORDER", state.preOrder);
                    return resolve(data);
                })
                .catch(function (error) {
                    return reject("There was an error saving the Pre Order Details to the server.");
                })
        });
    }
}
